var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.post
    ? _c(
        "div",
        [
          _c("h1", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("term.explanation"))),
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "title is-5" }, [
            _vm._v(_vm._s(_vm.$t("term.question"))),
          ]),
          _vm._v(" "),
          _c("post-content", {
            attrs: { post: _vm.post, "is-disp-title": false },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block mt-6" },
            [
              _c("h3", { staticClass: "title is-5" }, [
                _vm._v(_vm._s(_vm.$t("term.answer"))),
              ]),
              _vm._v(" "),
              _vm.post.answerType === "text"
                ? _c("div", { staticClass: "block" }, [
                    _vm._v(_vm._s(_vm.post.correctAnswerText)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.post.answerType == "select"
                ? _c("select-type-answers-content", {
                    attrs: {
                      answers: _vm.post.answersHtml,
                      "correct-answer": _vm.post.correctAnswer,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block mt-6" },
            [
              _c("h3", { staticClass: "title is-5" }, [
                _vm._v(_vm._s(_vm.$t("form.answerExplanation"))),
              ]),
              _vm._v(" "),
              _c("html-content", {
                staticClass: "mt-2",
                attrs: { body: _vm.post.answerExplanationHtml },
              }),
              _vm._v(" "),
              "answerExpImages" in _vm.post &&
              _vm.post.answerExpImages.length > 0
                ? _c(
                    "ul",
                    _vm._l(_vm.post.answerExpImages, function (image) {
                      return _c(
                        "li",
                        { key: image.fileId, staticClass: "image" },
                        [
                          _c("fb-img", {
                            staticClass: "mt-4",
                            attrs: {
                              fileId: image.fileId,
                              mimeType: image.mimeType,
                              size: "raw",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.post.category
            ? _c(
                "nav",
                {
                  staticClass: "breadcrumb",
                  attrs: { "aria-label": "breadcrumbs" },
                },
                [
                  _c(
                    "ul",
                    [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: `/posts/${_vm.serviceId}/` } },
                            [_vm._v(_vm._s(_vm.$t("common.posts")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.post.category.parents, function (parent) {
                        return _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: `/posts/${_vm.serviceId}/categories/${parent.slug}`,
                                },
                              },
                              [_vm._v(_vm._s(parent.label))]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: `/posts/${_vm.serviceId}/categories/${_vm.post.category.slug}`,
                              },
                            },
                            [_vm._v(_vm._s(_vm.post.category.label))]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          "tags" in _vm.post && _vm.post.tags
            ? _c(
                "ul",
                _vm._l(_vm.post.tags, function (tag) {
                  return _c(
                    "li",
                    { staticClass: "is-inline-block mr-2" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "tag",
                          attrs: {
                            to: `/posts/${_vm.serviceId}/tags/${tag.label}`,
                          },
                        },
                        [_vm._v(_vm._s(tag.label))]
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }